import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-add',
  imports: [],
  templateUrl: './add.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './add.component.scss',
})
export class AddComponent {}
